import moment from 'moment';
import isDate from 'lodash/isDate';

export const tryParseDate = (dateString) => {
  if (isDate(dateString)) return dateString;
  if (!dateString) return null;

  if (typeof (dateString) === 'object') {
    return new Date(dateString.value);
  }

  if (dateString.includes('T')) {
    return new Date(dateString);
  }

  if (dateString.length === 10 && dateString.includes('-')) {
    return moment(dateString, 'YYYY-MM-DD').toDate();
  }

  if (dateString.length === 10 && dateString.includes('.')) {
    const parsed = moment(dateString, 'DD.MM.YYYY', true);
    return parsed.toDate();
  }

  try {
    const parsed = moment(dateString, 'DD.MM.YYYY', true);
    return parsed.toDate();
  } catch (e) {
    return null;
  }
};
